import * as tslib_1 from "tslib";
import * as React from 'react';
import { TaskStatus } from 'src/models/TaskStatus';
import { formatDigits } from 'src/utils/numbers';
import { LinearProgress } from 'material-ui';
var styles = {
    item: {
        margin: '.2rem 0',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        gridTemplateRows: '1fr auto',
        backgroundColor: '#fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
    },
    badge: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        width: '2rem',
        color: '#fff',
    },
    title: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '.5rem',
        textAlign: 'left',
    },
    progress: {
        gridRow: 2,
        marginTop: '1px',
        borderRadius: 0
    }
};
var itemColor = function (item) { return TaskStatus.colorify(item.statusId); };
var TimeOverviewElement = /** @class */ (function (_super) {
    tslib_1.__extends(TimeOverviewElement, _super);
    function TimeOverviewElement(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            e.preventDefault();
            _this.props.onClick(_this.props.item.userItemId);
        };
        return _this;
    }
    TimeOverviewElement.prototype.render = function () {
        var item = this.props.item;
        var color = itemColor(item);
        var badgeStyle = tslib_1.__assign({}, styles.badge, { backgroundColor: color });
        return (React.createElement("div", { style: styles.item, onClick: this.handleClick },
            React.createElement("div", { style: tslib_1.__assign({}, badgeStyle, { gridRow: 1, gridColumn: 1 }) },
                React.createElement("div", null,
                    React.createElement("strong", null, formatDigits(item.hours, 1))),
                React.createElement("div", null,
                    React.createElement("small", null, "\u00F3ra"))),
            React.createElement("div", { style: tslib_1.__assign({}, styles.title, { gridRow: 1, gridColumn: 2 }) },
                React.createElement("div", { className: "text" },
                    React.createElement("small", null, item.title)),
                React.createElement("div", { className: "text text-muted" },
                    React.createElement("small", null, item.subtitle),
                    React.createElement("small", { style: { float: 'right' } }, item.competency))),
            React.createElement(LinearProgress, { style: tslib_1.__assign({}, styles.progress, { backgroundColor: color, gridColumn: 'span 2', width: item.percentage + "%" }), color: color, mode: "determinate", max: 100 })));
    };
    return TimeOverviewElement;
}(React.Component));
export default TimeOverviewElement;



//////////////////
// WEBPACK FOOTER
// ./src/pages/timeoverview/TimeOverviewElement.tsx
// module id = 786
// module chunks = 0